import script from "./Branches.vue?vue&type=script&setup=true&lang=js"
export * from "./Branches.vue?vue&type=script&setup=true&lang=js"

import "./Branches.vue?vue&type=style&index=0&id=a47822ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a47822ca"]])

export default __exports__